import { setupListeners } from "@reduxjs/toolkit/query";
import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import { authApi, logApi } from "query-slices/basic";
import global from "slices/global/slice";
import myProxiesUserPage from "../slices/pages/user/myProxies/slice";
import myProxiesAdminPage from "../slices/pages/admin/myProxies/slice";
import promoCodesAdminPage from '../slices/pages/admin/promoCodes/slice';
import costsAdminPage from "../slices/pages/admin/costs/slice";
import dashboardAdminPage from "../slices/pages/admin/dashboard/slice";
import customersAdminPage from "../slices/pages/admin/customers/slice";
import customerProxyAdminPage from "../slices/pages/admin/customerProxy/slice";
import customerHistoryAdminPage from "../slices/pages/admin/customerHistory/slice";

export const store = configureStore({
  reducer: {
    global,
    myProxiesUserPage,
    myProxiesAdminPage,
    promoCodesAdminPage,
    costsAdminPage,
    dashboardAdminPage,
    customersAdminPage,
    customerProxyAdminPage,
    customerHistoryAdminPage,
    [authApi.reducerPath]: authApi.reducer,
    [logApi.reducerPath]: logApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(authApi.middleware).concat(logApi.middleware),
});

setupListeners(store.dispatch);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
export type SliceAction<T> = {
  payload: T;
  type: string;
};
export type PartialExcept<T, K extends keyof T = keyof T> = Partial<
  Omit<T, K>
> &
  Pick<T, K>;
